import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IFeatureFlagsPermissions } from './feature-flags-permissions.interface';

// Per-user permission object for this instance (read/write), resolved from the org groups.
const PERMISSIONS_PATH = '/service/me/permissions';

/**
 * Backend call that establishes *authorization* (org-group read/write rights), as opposed to the
 * *authentication* (token issuance) handled by the auth providers. A valid token only proves
 * identity; only the service knows this instance's allowed groups, so the rights are resolved
 * against a guarded route after login.
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagsAuthApiService {
  private readonly http = inject(HttpClient);

  /**
   * Reads the user's per-instance read/write permissions; doubles as the authorization gate
   * (a `403`/error on a valid token means the user may not use the tool). The token is passed
   * explicitly because this runs during login before the session reaches the store, so the auth
   * interceptor cannot attach it yet.
   */
  getPermissions(accessToken: string): Observable<IFeatureFlagsPermissions> {
    return this.http.get<IFeatureFlagsPermissions>(PERMISSIONS_PATH, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }
}
